import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../crud.service';
import { BulkTransfer } from '../models';

@Injectable()
export class BulkTransferService extends ApiBaseService {

  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient, '/service/metatrader/trading_performance_fee?receiving_email=')
   }

   post(file: File, receiving_email: string = 'finance@eightcap.com'): Observable<BulkTransfer> {
     return this.httpClient.post<File>(`${this.basePath}${receiving_email}`, file, 
      {headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }})
   }
}
